import get from 'lodash.get'
export const CashmereDetailsForm = {
  title: 'Cachemere details',
  display: 'Cachemere',
  key: [],
  sections: [
    {
      columns: 2,
      fields: [
        {
          label: 'Design',
          type: 'select',
          isRequired: true,
          key: ['cashmereDesignRef'],
          options: [
            { key: 'cardigan_pocket', label: '1 - Cardigan pocket' },
            { key: 'cardigan_button', label: '2 - Cardigan button' },
            { key: 'cardigan', label: '3 - Cardigan' },
            { key: 'round_neck_classic', label: '4 - Round neck classic' },
            { key: 'round_neck_casual', label: '5 - Round neck casual 2' },
            { key: 'zip_neck', label: '6 - Zip neck' },
            { key: 'turtle_neck', label: '7 - Turtle neck' },
            { key: 'v_neck_classic', label: '8 - V neck classic' },
            { key: 'v_neck_casual', label: '9 - V neck casual' },
          ],
          pos: {
            col: 1,
            size: 2,
          },
        },
        {
          label: 'Fabric ref',
          isRequired: true,
          placeholder: '-',
          key: ['fabricRef'],
          pos: {
            col: 1,
            size: 1,
          },
        },
        {
          label: 'Size in cm',
          type: 'basicRadio',
          isRequired: true,
          key: ['size'],
          options: [
            { key: '48', label: '48' },
            { key: '50', label: '50' },
            { key: '52', label: '52' },
            { key: '54', label: '54' },
            { key: '56', label: '56' },
            { key: '58', label: '58' },
            { key: 'others', label: 'Others' },
          ],
          pos: {
            col: 1,
            size: 2,
          },
        },
        {
          label: 'Input size',
          type: 'number',
          isRequired: true,
          placeholder: '-',
          key: ['otherSize'],
          isHiding: (values, name) =>
            get(values, `${name}size`, '') !== 'others',
          pos: {
            col: 1,
            size: 1,
          },
        },
        {
          label: 'Comment',
          type: 'text',
          key: ['comment'],
          pos: {
            col: 1,
            size: 1,
          },
        },
      ],
    },
  ],
}

export const CashmereMeasureForm = {
  title: 'Final measurement Cashemere',
  display: 'Cashmere',
  key: [],
  sections: [
    {
      columns: 2,
      fields: [
        {
          label: 'Trial sample picture',
          type: 'multiupload',
          isRequired: false,
          key: ['trialSamplePicture'],
          requestURI: '/files/order-trial-sample',
          storageURI: '/storage/order-trial-sample',
          pos: {
            col: 1,
            size: 1,
          },
        },
        {
          label: 'Trial sample size',
          isRequired: false,
          placeholder: '-',
          key: ['trialSampleSize'],
          pos: {
            col: 1,
            size: 1,
          },
        },
        {
          label: 'Comment',
          type: 'text',
          isRequired: false,
          key: ['trialComment'],
          pos: {
            col: 1,
            size: 1,
          },
        },
      ],
    },
  ],
}
